import React from "react";
import SectionComponent from "components/common/Section/SectionComponent";
import UserCollections from "./UserCollections";
const UserCollectionsSection = ({ user }) => /* @__PURE__ */ React.createElement(SectionComponent, { title: "Collections" }, /* @__PURE__ */ React.createElement(UserCollections, { userId: user.id }));
export default UserCollectionsSection;
